import Fetch from "utils/fetch";

export const getIntegracoes = async () => {
    const response = await Fetch.get(`/integracao/obterIntegracao`);
    return response.data;
};

export const getAllTiposIntegracao = async () => {
    const response = await Fetch.get(`/integracao/todos-tipos`);
    return response.data;
};

export const getHistoricoExecucoes = async ({ tipoIntegracao, dataInicio, dataFim, pagina = 1, tamanhoPagina = 20, incluirLogs = true } = {}) => {
    const params = new URLSearchParams();
    if (tipoIntegracao != null) params.append('tipoIntegracao', tipoIntegracao);
    if (dataInicio) params.append('dataInicio', dataInicio);
    if (dataFim) params.append('dataFim', dataFim);
    params.append('pagina', pagina);
    params.append('tamanhoPagina', tamanhoPagina);
    params.append('incluirLogs', incluirLogs);
    const response = await Fetch.get(`/integracao/historico-execucoes?${params.toString()}`);
    return response.data;
};

export const cancelarIntegracao = async (tipoIntegracao) => {
    const response = await Fetch.post(`/integracao/cancelar/${tipoIntegracao}`);
    return response.data;
};

export const getStatusAtualIntegracao = async (tipoIntegracao, incluirLogs = true) => {
    const response = await Fetch.get(`/integracao/status-atual/${tipoIntegracao}?incluirLogs=${incluirLogs}`);
    return response.data;
};

export const getWallets = async () => {
    const response = await Fetch.get(`/material-groups:all`);
    return response.data;
};

export const getLabeledFamilies = async () => {
    const response = await Fetch.get(`/labeled-families:all-with-labeled-family-centers`);
    return response.data;
};




